import * as React from "react";
const SvgBurn = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 69, cy: 67, r: 12, style: {
  stroke: "gray",
  fill: "gray",
  fillOpacity: 1,
  strokeOpacity: 1
}, transform: "translate(-5 -3)" }));
export default SvgBurn;
